import { combineReducers } from "redux";
import { LOG_IN } from "./actions";

const authInitialState = {
  loggedIn: false,
};

function authReducer(state = authInitialState, action) {
  switch (action.type) {
    case LOG_IN:
      return {
        ...state,
        accessToken: action.accessToken,
        loggedIn: true,
      };
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  auth: authReducer,
  // add more reducers here
});

export default rootReducer;
